var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleaningImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.57,200.9S697.55,119.21,583,68.76s-167.54-.24-225.11,20.7S269.12,81.58,173,68-6.36,189.68,20.87,295.39s87.29,143.35,218.62,167.37,209-55.26,301.91-40.84S744.8,355.45,713.57,200.9Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.57,200.9S697.55,119.21,583,68.76s-167.54-.24-225.11,20.7S269.12,81.58,173,68-6.36,189.68,20.87,295.39s87.29,143.35,218.62,167.37,209-55.26,301.91-40.84S744.8,355.45,713.57,200.9Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.62,64.53a68,68,0,0,1,5.91,27.82V295H213.12V92.35a68.2,68.2,0,0,1,68.21-68.2h0a68.19,68.19,0,0,1,59.72,35.24",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.77,45.9a52.72,52.72,0,0,1,20.56-4.15h0a52.8,52.8,0,0,1,52.8,52.8v199.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.52,294.25V94.55a52.79,52.79,0,0,1,29.11-47.19",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.33,
    y1: 105.93,
    x2: 281.33,
    y2: 294.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.33,
    y1: 24.15,
    x2: 281.33,
    y2: 100.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.86,
    y1: 84.47,
    x2: 348.62,
    y2: 84.47,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.94,
    y1: 126.85,
    x2: 348.62,
    y2: 126.85,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.86,
    y1: 126.85,
    x2: 230.5,
    y2: 126.85,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.86,
    y1: 169.39,
    x2: 348.62,
    y2: 169.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.79,
    y1: 211.93,
    x2: 348.62,
    y2: 211.93,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.86,
    y1: 211.93,
    x2: 321.51,
    y2: 211.93,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.57,
    y1: 254.46,
    x2: 348.62,
    y2: 254.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.86,
    y1: 254.46,
    x2: 256.02,
    y2: 254.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.88,
    y1: 45.43,
    x2: 244.1,
    y2: 56.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.27,
    y1: 45.43,
    x2: 318.05,
    y2: 56.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.51,64.53a68,68,0,0,1,5.92,27.82V295H387V92.35a68.2,68.2,0,0,1,68.21-68.2h0A68.21,68.21,0,0,1,515,59.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.67,45.9a52.63,52.63,0,0,1,20.55-4.15h0A52.81,52.81,0,0,1,508,94.55v199.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.42,294.25V94.55a52.78,52.78,0,0,1,29.1-47.19",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 455.22,
    y1: 105.93,
    x2: 455.22,
    y2: 294.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 455.22,
    y1: 24.15,
    x2: 455.22,
    y2: 100.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.75,
    y1: 84.47,
    x2: 522.51,
    y2: 84.47,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.83,
    y1: 126.85,
    x2: 522.51,
    y2: 126.85,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.75,
    y1: 126.85,
    x2: 404.39,
    y2: 126.85,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.75,
    y1: 169.39,
    x2: 522.51,
    y2: 169.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 501.69,
    y1: 211.93,
    x2: 522.51,
    y2: 211.93,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.75,
    y1: 211.93,
    x2: 495.4,
    y2: 211.93,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.47,
    y1: 254.46,
    x2: 522.51,
    y2: 254.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.75,
    y1: 254.46,
    x2: 429.92,
    y2: 254.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.77,
    y1: 45.43,
    x2: 417.99,
    y2: 56.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 504.16,
    y1: 45.43,
    x2: 491.94,
    y2: 56.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-63"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22.14,
    y1: 388.15,
    x2: 738.51,
    y2: 388.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2,265.23h0a.08.08,0,0,0,0-.09.08.08,0,0,0-.09,0,85.86,85.86,0,0,0-4.47,14,129.44,129.44,0,0,0-2.46,14.52l-.35,3.68c-.06.61-.12,1.22-.17,1.83l-.1,1.84c-.05,1.23-.13,2.46-.16,3.69l0,3.69,0,1.84c0,.62.07,1.23.12,1.84.09,1.23.16,2.46.28,3.68.23,2.45.6,4.88,1,7.3a.06.06,0,0,0,.06.06.06.06,0,0,0,.06-.07h0c0-1.23,0-2.45-.08-3.68s-.14-2.44-.13-3.66,0-2.44,0-3.66l0-1.83,0-1.83,0-3.66.1-3.65,0-1.83c0-.61.07-1.22.1-1.82l.22-3.66a130.75,130.75,0,0,1,2.07-14.48A84.11,84.11,0,0,1,58.2,265.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.72,284.35a.07.07,0,0,0,0-.08.06.06,0,0,0-.08,0,86.77,86.77,0,0,0-2.6,9.28,87.73,87.73,0,0,0-1.54,9.54c-.32,3.2-.68,6.41-.73,9.62a81.84,81.84,0,0,0,.35,9.65.06.06,0,0,0,.05.06.08.08,0,0,0,.08-.06c.37-3.2.59-6.4.82-9.59s.25-6.4.46-9.59a84.6,84.6,0,0,1,1.14-9.5A88.58,88.58,0,0,1,58.72,284.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.32,291.07a.07.07,0,0,0-.09,0,32.62,32.62,0,0,0-7.09,6.18,29.36,29.36,0,0,0-2.77,3.85l-.57,1.08-.44,1.12a11.6,11.6,0,0,0-.39,1.13c-.11.38-.24.76-.35,1.14a45.73,45.73,0,0,0-1.46,9.35,53.81,53.81,0,0,0,.35,9.41.06.06,0,0,0,.06.06s.07,0,.07-.06l.81-9.32a82.74,82.74,0,0,1,1.18-9.19c.08-.38.19-.74.28-1.11a10,10,0,0,1,.33-1.1l.38-1.08.49-1a26.67,26.67,0,0,1,2.54-3.85,32.18,32.18,0,0,1,6.65-6.48h0A.07.07,0,0,0,69.32,291.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.19,303.05A10.34,10.34,0,0,0,61,306.92a22.58,22.58,0,0,0-1.81,4.75c-.12.4-.22.81-.31,1.23l-.29,1.24a21.26,21.26,0,0,0-.32,2.51c0,.85,0,1.69,0,2.54a21.31,21.31,0,0,0,.34,2.51.06.06,0,0,0,0,.06.08.08,0,0,0,.08-.06,24.17,24.17,0,0,0,.44-2.47c.13-.82.26-1.64.36-2.45s.23-1.63.29-2.45.17-1.63.35-2.43a22,22,0,0,1,1.38-4.7,10.34,10.34,0,0,1,2.71-4h0a.06.06,0,0,0,0-.08A.07.07,0,0,0,64.19,303.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.33,312.38c-.35-4.13-1-8.23-1.68-12.32s-1.36-8.18-2.11-12.26-1.58-8.13-2.46-12.18a.08.08,0,0,0-.08-.05.07.07,0,0,0,0,.08c.71,4.08,1.35,8.17,2,12.26s1.2,8.19,1.72,12.29.9,8.22,1.41,12.32l1.52,12.32a.06.06,0,0,0,.06.05s.06,0,.07-.06c0-1,0-2.07.07-3.11s0-2.08-.06-3.12C49.66,316.52,49.48,314.45,49.33,312.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.85,312.32c-.22-1.64-.53-3.26-.84-4.89L45.43,305c-.19-.81-.37-1.62-.61-2.41a67.53,67.53,0,0,0-3.16-9.41l-.49-1.14L40.61,291c-.35-.75-.77-1.47-1.17-2.19a18.65,18.65,0,0,0-3-4,.06.06,0,0,0-.09.09h0A18.34,18.34,0,0,1,39.1,289c.36.73.74,1.46,1,2.22l.48,1.12.43,1.15a67.15,67.15,0,0,1,2.76,9.41c.38,1.6.63,3.22.94,4.82l.38,2.43c.14.8.32,1.61.43,2.42.26,1.61.55,3.23.84,4.85s.54,3.24.89,4.86a.06.06,0,0,0,.06.06s.06,0,.07-.07c0-1.65,0-3.31-.12-5S47,314,46.85,312.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.42,312.54a68.32,68.32,0,0,0-2.62-6.38,57,57,0,0,0-3.29-6.05.1.1,0,0,0-.09,0,.07.07,0,0,0,0,.09,59,59,0,0,1,2.81,6.23c.84,2.12,1.6,4.27,2.23,6.45s1.11,4.4,1.69,6.59,1.1,4.39,1.78,6.61a.06.06,0,0,0,.06.05A.07.07,0,0,0,46,326a32.4,32.4,0,0,0-.64-6.88A43.08,43.08,0,0,0,43.42,312.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.28,319.77A14.74,14.74,0,0,0,41.46,316a15.93,15.93,0,0,0-2.65-3.3,12.23,12.23,0,0,0-1.69-1.27,6.71,6.71,0,0,0-1.91-.86.07.07,0,0,0-.08,0,.07.07,0,0,0,0,.09h0a9.59,9.59,0,0,1,3.18,2.47,15.49,15.49,0,0,1,2.21,3.34c.63,1.19.95,2.5,1.5,3.73.24.63.48,1.26.75,1.89a16.59,16.59,0,0,0,.84,1.91h0a.1.1,0,0,0,.05,0,.07.07,0,0,0,.07-.07,14.83,14.83,0,0,0-.08-2.11A20.47,20.47,0,0,0,43.28,319.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.54,281.55a11.8,11.8,0,0,1-8.35-8.87c-1.56-7.3,3.48-4.17-1-15.65S30.67,243,32.24,239.65s2.43-2.26,3.82,2.09,6.43,11.12,8.35,23.81S43.54,281.55,43.54,281.55Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.92,269.2s-4.52-1.56-4.69-10.08,3.3-6.78,3.82-17.38,1.22-18.08,3.13-18.26,7,5.22,8.69,17-2.26,19.64-5.73,23.12S56.92,269.2,56.92,269.2Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1,291.8s-1-6.26-3.13-9.21-6.6-5.56-9.56-11.3-6.26-8.52-6.08-.35,3.82,12.34,8.34,15.13S41.1,291.8,41.1,291.8Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.19,302.58a62.4,62.4,0,0,0-10.26-13.91c-6.08-5.91-10.95-8.86-9.21-5.91s3.82,2.78,6.78,8,2.09,9,6.26,12S39.19,302.58,39.19,302.58Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.67,312.84c-.18-.52-.35-4.35-6.26-7.48s-11.47-1.91-10.78-.34,4.35,4.17,8,5.73A36.67,36.67,0,0,0,38.67,312.84Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.57,292.15s-2.6-3.3-1.21-10.26,4.52-5.21,8-8.86,2.79-4.17,6.26-8,6.61-5.91,8-4.35-.7,6.44-2.78,9.22-5.39,4.17-7,7.65-.86,9-4.86,11.65S56.57,292.15,56.57,292.15Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.27,294.06s6.26-7.12,10.78-12.34,6.25-9.21,6.43-5.74,1.56,6.26-2.09,10.78S65.27,294.06,65.27,294.06Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,305.54s-.17-2.78,9.74-9.22,14.08-7.65,13-5-5.39,5.22-10.09,9.91S62,305.54,62,305.54Z",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,280.81s-2.33-12.48-4.76-21.34-4-14.26-4-14.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.52,269.33s4.23-13.51,5.62-21.68-.18-14.26-.87-17.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.55,291.54a65.86,65.86,0,0,0-6.4-9.12c-3.83-4.52-6.78-7-8.52-11.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.57,292.15s1.4-8.34,4.7-12.69S71.18,268.33,73.79,264",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.26,312.65s-5.85-3.81-10-5.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,347.69c-.4-10.55-12.12-17.58-12.12-17.58h-18s-11.72,7-12.11,17.58,13.28,49.23,13.28,49.23H58.47S72.15,358.24,71.76,347.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.96 319.74 39.03 319.74 41.68 330.11 59.31 330.11 61.96 319.74",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.13,
    y: 58.5,
    width: 85.68,
    height: 110.16,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567.83,
    y: 64.53,
    width: 76.28,
    height: 98.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.94,
    y: 89.11,
    width: 38.05,
    height: 48.92,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.34,
    y: 58.5,
    width: 85.68,
    height: 110.16,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.04,
    y: 64.53,
    width: 76.28,
    height: 98.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.15,
    y: 89.11,
    width: 38.05,
    height: 48.92,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--file-cabinet--inject-63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 667.04,
    y: 182.19,
    width: 61.83,
    height: 215.8,
    transform: "translate(1395.91 580.17) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.24,
    y: 189.28,
    width: 54.03,
    height: 51.98,
    transform: "translate(1396.51 430.54) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.45,
    y: 210.54,
    width: 21.61,
    height: 9.45,
    transform: "translate(1396.51 430.54) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.24,
    y: 249.92,
    width: 54.03,
    height: 51.98,
    transform: "translate(1396.51 551.82) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.45,
    y: 271.19,
    width: 21.61,
    height: 9.45,
    transform: "translate(1396.51 551.82) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.24,
    y: 310.56,
    width: 54.03,
    height: 51.98,
    transform: "translate(1396.51 673.11) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.45,
    y: 331.83,
    width: 21.61,
    height: 9.45,
    transform: "translate(1396.51 673.11) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "705.98 159.87 709.32 150.74 707.54 152.74 707.54 149.62 703.75 155.41 707.09 134.7 702.64 146.06 702.2 136.04 701.53 139.38 700.64 128.02 699.08 145.39 696.85 139.38 697.3 147.17 691.28 129.36 694.18 151.63 689.95 148.51 692.4 152.52 689.28 150.29 692.84 160.53 705.76 160.76",
    style: {
      fill: "#008C8E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691.69 182.35 705.62 182.35 709.37 158.23 687.94 158.23 691.69 182.35",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-2--inject-63"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 528.21,
    y1: 396.85,
    x2: 532.4,
    y2: 307.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 534.85,
    y1: 396.82,
    x2: 540.43,
    y2: 279.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 612.38,
    y1: 396.82,
    x2: 606.44,
    y2: 280.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 618.32,
    y1: 396.85,
    x2: 614.12,
    y2: 307.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.5,
    y: 215.63,
    width: 74.83,
    height: 68,
    rx: 4.5,
    style: {
      fill: "#c4c4c4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.69,312.81h-88a4.26,4.26,0,0,1-4.25-4.26h0a4.26,4.26,0,0,1,4.25-4.25h88a4.26,4.26,0,0,1,4.26,4.25h0A4.26,4.26,0,0,1,618.69,312.81Z",
    style: {
      fill: "#c4c4c4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.61,
    y: 256.28,
    width: 60.7,
    height: 2.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.21,
    y: 194.97,
    width: 65.74,
    height: 50.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.55,
    y: 194.97,
    width: 65.74,
    height: 50.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "530.89 256 514.58 256 510.01 258.59 530.89 258.59 530.89 256",
    style: {
      fill: "#c7c7c7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "521.47 258.59 505.56 258.59 510.13 213.02 526.03 213.02 521.47 258.59",
    style: {
      fill: "#c7c7c7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.07,269.37l10.68,127a1.38,1.38,0,0,0,1.67,1.16,1.36,1.36,0,0,0,1-1.47l-7.27-126.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.11,269.37l10.71,127.42a1.39,1.39,0,0,0,1.67,1.16,1.36,1.36,0,0,0,1-1.47l-7.29-127.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,269.37,448.4,395.25a1.38,1.38,0,0,0,1,1.48h0a1.34,1.34,0,0,0,1.66-1.13l9-126.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.54,269.37l-5.61,125.46a1.38,1.38,0,0,0,1,1.48,1.34,1.34,0,0,0,1.66-1.14l9-125.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.55,
    y: 262.33,
    width: 215.67,
    height: 10.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.55,
    y: 262.33,
    width: 215.67,
    height: 3.74,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.17,
    y: 258.7,
    width: 222.44,
    height: 4.16,
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table-1--inject-63"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 169.78,
    y1: 396.85,
    x2: 173.97,
    y2: 307.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.42,
    y1: 396.82,
    x2: 182.01,
    y2: 279.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.95,
    y1: 396.82,
    x2: 248.01,
    y2: 280.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.89,
    y1: 396.85,
    x2: 255.7,
    y2: 307.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.08,
    y: 215.63,
    width: 74.83,
    height: 68,
    rx: 4.5,
    style: {
      fill: "#c4c4c4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.27,312.81h-88a4.26,4.26,0,0,1-4.26-4.26h0a4.26,4.26,0,0,1,4.26-4.25h88a4.26,4.26,0,0,1,4.25,4.25h0A4.26,4.26,0,0,1,260.27,312.81Z",
    style: {
      fill: "#c4c4c4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.18,
    y: 256.28,
    width: 60.7,
    height: 2.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.79,
    y: 194.97,
    width: 65.74,
    height: 50.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.13,
    y: 194.97,
    width: 65.74,
    height: 50.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.46 256 156.15 256 151.58 258.59 172.46 258.59 172.46 256",
    style: {
      fill: "#c7c7c7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.04 258.59 147.14 258.59 151.7 213.02 167.61 213.02 163.04 258.59",
    style: {
      fill: "#c7c7c7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.65,269.37l10.67,127a1.39,1.39,0,0,0,1.67,1.16,1.36,1.36,0,0,0,1-1.47l-7.27-126.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.68,269.37l10.71,127.42a1.39,1.39,0,0,0,1.67,1.16,1.36,1.36,0,0,0,1-1.47L282.8,269.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6,269.37,90,395.25a1.39,1.39,0,0,0,1,1.48h0a1.33,1.33,0,0,0,1.65-1.13l9-126.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.11,269.37,81.5,394.83a1.39,1.39,0,0,0,1,1.48,1.34,1.34,0,0,0,1.65-1.14l9-125.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.13,
    y: 262.33,
    width: 215.67,
    height: 10.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.13,
    y: 262.33,
    width: 215.67,
    height: 3.74,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.74,
    y: 258.7,
    width: 222.44,
    height: 4.16,
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "482.46 206.69 487.06 186.63 489.72 197.81 482.46 206.69",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "489.72 197.81 482.46 206.69 497.53 219.07 489.72 197.81",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,135.47s-14.64.59-20.11,7.81S430.24,155,431,161.44s4.3,8.2,4.3,8.2,2.24,7.84,5,10.38,7.28,3.29,8.06,5.44c.55,1.5,1,4.73,2.07,6s4,1.43,5,0c0,0,9.56,4.16,12.68,1.82s5.27-9,5.27-9a60.23,60.23,0,0,0,7.42.78,19,19,0,0,1,6.25,1.56s-2.73-11.32-3.9-17.18-4.69-18.36-8.4-25.39S462.07,134.3,456,135.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.22,171.79c1.56-1.17,2.34-5.08,4.69-5.27s6.25,3.71,13.86,3.51,9.18-3.12,9.18-3.12,1.17,1,2.34-1.37.2-5.66,3.32-6.25,5.47,6.45,5.47,8.2c0,1.32,2.73,1.76,4.93,1.24-1.3-6.1-4.68-17.9-8.25-24.67-3.71-7-12.69-9.76-18.75-8.59,0,0-14.64.59-20.11,7.81S430.24,155,431,161.44s4.3,8.2,4.3,8.2S437.66,173,439.22,171.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.18,181.36s3.71-4.3,7.62-4.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.08,182.33s3.32,1,5.08-4.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.36,190.34s2.14.2,3.9-2.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.08,167.49s.19,3.91-1.95,4.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.48 474.37 350.87 451.62 379.97 442.57 463.59 465.32 434.48 474.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.72 470.43 364.85 453.32 386.73 446.51 449.61 463.62 427.72 470.43",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.64,457.73a3.27,3.27,0,0,1-2.7-5.13L542.3,246.31a3.28,3.28,0,1,1,5.41,3.71L406.35,456.31A3.25,3.25,0,0,1,403.64,457.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.94,452.6a3.27,3.27,0,0,0,2.7,5.13,3.25,3.25,0,0,0,2.71-1.42l24.54-35.81-6.67-1.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.13,273.4s2.22-1.82,2.38-3.22-.74-4.53-1.44-4.43-.83,2.35-.83,2.35a7,7,0,0,1,.5,2.65",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.61,280.32s2.06-.43,3-.6,3.56-3.36,3.58-5.2-1.16-2.07-2-.93S526.61,280.32,526.61,280.32Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.41,276.72s2.3-2,2.72-3.32,1.22-5.29.11-5.3-1.64-.93-2,.76-.62,3.74-.62,3.74A18.76,18.76,0,0,0,532.41,276.72Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.34,236.19l-3.57,28.59s-2.47,10.17-3.85,15.66-6,22-6,22l14.56.83,13.47-38.21,3.3-28.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.14,293.52,505.79,303,492.9,323s2.35,8.78,2.35,10a2.61,2.61,0,0,1-1.32,2.35c-.73.43-1.47.87-1.47,1.31s.44,2.79-.44,3.81-3.51,1.17-3.51,1.17,2.2,3.22-.59,5-5-3.22-6-2.34-.59,10.69-1.76,12-3.07-.14-3.22-1.31-1.32-11-1.32-13.62,1.47-18.6,2.79-22.84S485.14,293.52,485.14,293.52Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.25,361.46l5.65,78.06s-11.3,7-15.61,9.42-11.84,4.58-12.65,6.46-.23,6.44,7.29,7.66,20.44-.66,20.44-.66,14.8,4,17.76,3.23,3.5-5.92,3.77-9.15-3.5-22.34-3.5-22.34,4.58-54.37,3.23-63.53-2.69-28.26-2.69-28.26l1.88-12.11-28.26-1.35Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.4,434.14l.11-1.29c-6.66,2.62-14.19,1.64-18,.84l.42,5.83s-11.3,7-15.61,9.42-11.84,4.58-12.65,6.46-.23,6.44,7.29,7.66,20.44-.66,20.44-.66,14.8,4,17.76,3.23,3.5-5.92,3.77-9.15S562.4,434.14,562.4,434.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.4,434.14l.11-1.29c-6.66,2.62-14.19,1.64-18,.84l.42,5.83s-11.3,7-15.61,9.42-11.84,4.58-12.65,6.46-.23,6.44,7.29,7.66,20.44-.66,20.44-.66,14.8,4,17.76,3.23,3.5-5.92,3.77-9.15S562.4,434.14,562.4,434.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.4,434.14l.11-1.29c-6.66,2.62-14.19,1.64-18,.84l.42,5.83s-11.3,7-15.61,9.42-11.84,4.58-12.65,6.46-.23,6.44,7.29,7.66,20.44-.66,20.44-.66,14.8,4,17.76,3.23,3.5-5.92,3.77-9.15S562.4,434.14,562.4,434.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.26,443c-3.48,2.13-7.7,4.68-10,5.95-4.3,2.43-11.84,4.58-12.65,6.46s-.23,6.44,7.29,7.66,20.44-.66,20.44-.66,14.8,4,17.76,3.23,3.5-5.92,3.77-9.15c.11-1.37-.5-5.58-1.24-10a80.5,80.5,0,0,1-11.14,3C546.3,450.88,541.33,445.72,539.26,443Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.13,465.63c1.76-.48,2.66-2.48,3.16-4.7-3.86,1.64-11.09.1-15.27-.95s-7.81.54-21.27,1.08c-6,.24-9.65-.81-11.85-2.05.86,1.7,2.89,3.38,7,4.05,7.52,1.23,20.44-.66,20.44-.66S559.17,466.44,562.13,465.63Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.24,244.64s4.85,15.61,3,24.77-51.41,80.21-51.41,80.21-4.58,32.57-9.42,51.14-13.19,36.34-13.73,41.45.54,21.27.27,24.23-21.27,6.46-29.61,8.34-26.65-2.42-26.65-5.92,17.52-8.93,22.61-12.65c7.22-5.27,18.61-20.91,18.31-23.69-.35-3.13,8.88-60.56,8.88-68.37s.81-18.84,2.15-22.34,6.73-18.3,6.73-18.3,31-57.34,31.5-72.41,4.57-14,8.61-15.07S590.4,237.91,595.24,244.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.74,218.8s11.58,23.69,11.58,28-8.62,8.08-8.62,8.08l-11.84-35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.62,435.37a41.56,41.56,0,0,1-17.06-3.09,1.56,1.56,0,0,0,0,.24c.3,2.78-11.09,18.42-18.31,23.69-5.09,3.72-22.61,9.15-22.61,12.65s18.31,7.81,26.65,5.92,29.34-5.38,29.61-8.34-.81-19.11-.27-24.23A37.14,37.14,0,0,1,525.62,435.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.91,466.44c.16-1.71-.14-7.85-.31-13.7-3.07,1.93-6.74,3.54-9.92,2.93-7-1.34-5.92-4.3-7.81-6.73-1.29-1.66-4.24-2.31-5.95-2.55a59.73,59.73,0,0,1-9.66,9.82c-5.09,3.72-22.61,9.15-22.61,12.65s18.31,7.81,26.65,5.92S523.64,469.4,523.91,466.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.91,466.44c.06-.62.05-1.82,0-3.38-6.85,2.82-20.53,7.66-34.74,8.22-14.48.58-19.13-2.3-20.6-4a2.38,2.38,0,0,0-.94,1.55c0,3.5,18.31,7.81,26.65,5.92S523.64,469.4,523.91,466.44Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.41,235.76l-5.92,28s-4.85,8.89-3.77,10a33.1,33.1,0,0,0,4.9,3.15l8.35-10.5,8.55-19Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.91,263.75s-1.35,7-3,9.42-4.58,4.85-1.89,5.66,8.35-7,9.69-9.16,1.89-8.34,1.89-8.34",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.29,229.84s9.43,11.84,12.66,17.22,5.11,18,4,27.19-14.53,53.57-14.53,53.57,10.5,5.11,27.72,6.46,32.57,1.88,32.57,1.88,9.15-62.18,7.54-78.6-9.69-36.07-9.69-36.07l2.15-2.69L583,217l-55,2.93Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.12,243.34c1.6-.43,3.24-.89,4.89-1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.14,247.63a120.2,120.2,0,0,0,25.36-3.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.52,247.33s3.93,4.54,20.14,7.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580.3,
    y1: 221.65,
    x2: 572.12,
    y2: 227.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 579.23,
    y1: 225.56,
    x2: 572.47,
    y2: 233.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.58,258.3s7.11,11.39,14.23,15.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583,217s.93-10,3.09-10,7.27,5.65,5.92,6.19-6.73,3.77-6.73,3.77L600.09,236l-4.85,4.57Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.06,186.63s2.6,14.31,5.59,22.65S496,239.5,496,239.5L523,240.6l5.28-19L583,217s-25.56-30.23-41.51-43.7-50.57-15.94-54.42-15.39a19.63,19.63,0,0,0-7.14,2.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "528.3 221.63 534.03 206.34 530.83 240.51 525.14 233.75 528.3 221.63",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.92,134.89a17,17,0,0,1,7.61-9c5.67-2.93,15-.58,18.16,3.32s4.89,9,7.62,10.94,8.2-3.32,13.08-.78,6.84,8.2,7.23,10.93,6.64-4.49,14.64-.78,9.37,15.23,7.62,18.75-10,9.17-19.53,2.34-15.62-12.3-17.18-10.55-1.56,10.74-8.2,6.06-12.89-21.09-17.19-26a15,15,0,0,0-10.35-4.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.73,159s7.8,15.62,8.88,21.54-1.89,17.23-1.89,17.23l-9.79-37.2Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.85,123s-2.27,5.55-1.76,7.57a6.22,6.22,0,0,1-.76,5.29c-1,1.26-2,2.52-1,3.53l1,1s1,8.32,2.27,9.58,4.54,1.26,4.54,1.26l.25,6.31a47.64,47.64,0,0,1,9.58-.26,67.91,67.91,0,0,0,8.07.51s-1.51-5.8-1-10.09,2.52-12.1.76-16.64-11.35-9.58-14.62-9.08S337.85,123,337.85,123Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.18,115.91a13.45,13.45,0,0,1-4.54-1.26c-1.76-1-5.29-1.26-4.28.76a32.92,32.92,0,0,1,1.76,4.54s-6.3-3-5-.76a18.76,18.76,0,0,0,2.77,3.78s.26,6.56,1.77,7.32.75,3,.5,5,0,3.78,1,3.78h1s1.51-2,2.77.76a20.86,20.86,0,0,1,1.77,6.8c.25,2,4.28,3.79,6.81,4s5.54-.51,6.05-1.26,5-6.81,6.55-12.61,0-13.11-3-16.14-8.58-5-8.58-5-4.79-6-5.79-4.29A17.5,17.5,0,0,0,347.18,115.91Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.64,
    y: 142.34,
    width: 1.25,
    height: 22.9,
    transform: "translate(-35.21 94.48) rotate(-18.77)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.56,143.9l-10.13,3.44a5,5,0,0,1-6.34-3.12l-10.43-38.73a3.77,3.77,0,0,1,2.35-4.76l7.59-2.58a3.76,3.76,0,0,1,4.76,2.34l15.33,37.07A5,5,0,0,1,270.56,143.9Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.88,177.5l3.46-.24-2.51-4.42A6.68,6.68,0,0,0,275.88,177.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.83,169.12l-12.1,2.52-18.41-8.83L272,167.1s9.84,15.63,12.61,17.14,26.73.26,26.73.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.79,156.25s-4.89-2.63-5.49-2.51a1.32,1.32,0,0,0-1.2,1.56c.24.95.6,2.14.6,2.14s-1.91,5.73-1.43,7.17a9.47,9.47,0,0,0,3.7,4.3,22.12,22.12,0,0,0,2.87.83l7,7.76s1.43-4.54,3.1-6.45a44.5,44.5,0,0,1,4.66-4.29s-5.49-4.78-5.85-5a21.12,21.12,0,0,1-1.91-3.46c-.48-1-1.79-1.43-3.34-2.39s-1.91-1.43-2.51-1.07S269.79,156.25,269.79,156.25Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.89,385.68s-.21,8.77.43,9.84,4.71,1.71,7.7,1.07,4.49-1.28,4.49-2.78-1.28-13.69-1.28-13.69l-11.76.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,396.59c3-.64,4.49-1.28,4.49-2.78,0-.19,0-.56-.06-1.05a18.31,18.31,0,0,1-12.48.57,6.9,6.9,0,0,0,.35,2.19C369,396.59,373,397.23,376,396.59Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.77,385.68s-4.92,2.36-7.91,3.64-11.77,3.42-12.41,4.49-.43,3.85.43,4.71,30.8,2.56,34.43,2.13,5.35-1.07,5.35-3V390.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.66,397.66v-1.51a26.23,26.23,0,0,1-5.35,2.37L299.1,396a4.2,4.2,0,0,0,.78,2.51c.86.85,30.8,2.56,34.43,2.13S339.66,399.58,339.66,397.66Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.14 186.53 394.13 230.21 390.14 254.92 383.4 255.41 382.4 226.22 376.66 195.02 388.14 186.53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.41,250.42l12.23,1.75-3,18.72s1.25,7,.5,9a16.32,16.32,0,0,1-5.49,6.24c-2,1.25-4,3-5.24.5s-3.5-13.23-3-14.72,3-7.74,3-7.74Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.9,268.89s-.75,5.74,0,7,2,3,2,3l-3.25,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.33,258.64l2.35,74.64-2.78,47.91-4.7,1.93-.43,2.56s9.41,4.92,12.19,5.56,7.06,1.29,7.06,1.29,4.49-27.38,4.92-29.73,3.42-36.58,3.42-36.58l4.71-35.07,3.63-.64,7.7,46.19,4.49,49s.64,1.29,4.71,1.93a12.84,12.84,0,0,0,6.84-.64l.22-17.76,1.28-48.33-3.42-64.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.53,233l6,23.74s-9,2.79-27.59,4.07-24.6-2.14-24.6-2.14L329,227.2s17.11,5.35,28.44,4.7,13-.64,13-.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.73,221.06s-3.1,41.43-3.1,48.7.64,27.16.64,27.16l5.13,2.78s1.07-35.5,2.35-45.12,4.5-23.32,4.5-23.32,21.6,2.36,23.95,2.36,12.62-.86,12.62-.86l1.71.21-.14-6.62s-16.33.85-27.88-1.5a104.57,104.57,0,0,1-20.74-6.63Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.85,232.76s-8.56-3.85-9.2-2.78-2.14,6-1.07,6.42,8.56-1.07,8.56-1.07a87.1,87.1,0,0,0-.43,14.33c.43,7.7,1.28,18.82,1.28,18.82l4.49-1.07s-1.49-18.61-1.92-20.75.43-10,.43-10,1.92,7.06,2.56,8.56,1.71,17.75,1.71,17.75l4.49-.64s-1.06-13.26-2.56-16.69-3.85-8.34-3.85-8.34,2.35,1.28,3,1.5a20,20,0,0,1,3,2.57s1.07-4.71.64-6.42-.86-1.5-3.42-1.93A53,53,0,0,0,354.85,232.76Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.39,157.52l-23.45,3.78-13.11,7.82,6.3,17.65,9.08-1.27s.51,33,2.52,35.56,12.86,6.55,20.43,7.31,21.18,1.76,23.45,1.51,3-1.76,3.78-3.53,5.55-20.93,5.55-20.93l3.53-10.33,11.85-5.3s-6.06-15.88-8.32-18.15S364.08,159.79,363.32,159s-3.28-1.26-3.28-1.26S347.18,155.25,342.39,157.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.86,167.6s3,7.06,6.81,15.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41,174.66s5.8,11.1,8.32,13.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.47,
    y1: 195.09,
    x2: 382.99,
    y2: 183.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.21,
    y1: 185.5,
    x2: 319.7,
    y2: 176.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bucket--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.47,421.64c-1.74-2.18-3-2.4-3-2.4L613,406.4l-.7-1.39-5.62-11.15s.58-1.17-.13-3.87-3.72-4.74-3.72-4.74l-7.46,2.95-6.81,4.24s-.15,3.64,1.6,5.82,3,2.4,3,2.4l5.62,11.15.7,1.39L606,426s-.58,1.17.13,3.87a4.58,4.58,0,0,0,.15.49c2.22,5.92,11.23,3.84,15.38-.62,2.06-2.21,2.92-5,1.17-7.71C622.68,421.92,622.58,421.78,622.47,421.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.14,
    y: 385.97,
    width: 15.54,
    height: 3.07,
    transform: "translate(-110.74 309.21) rotate(-26.75)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.38,
    y: 385.44,
    width: 28.83,
    height: 23.01,
    transform: "translate(-110.47 446.42) rotate(-35.28)",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "649.75 378.86 651.93 379.22 665.21 398 663.03 397.64 649.75 378.86",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.2,
    y: 385.07,
    width: 28.83,
    height: 23.01,
    transform: "translate(-110.66 445.09) rotate(-35.28)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.54,374.48s3,.28,3.41.64,1.43,2.35,2.28,3.27,2.21,1.42,2.21,1.14-2.35-4.2-3.06-6-1.5-2.2-1.85-2.2S632.54,374.48,632.54,374.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.91,367.73s-10.49.42-11,.55-5,2.77-5,2.77l1.1,4.14h2.35l-.22.71h6.69l3.19-4.3,3.18-.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.73,
    y: 367.36,
    width: 3.56,
    height: 4.48,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.13,
    y: 375.9,
    width: 6.69,
    height: 5.19,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.07 391.91 634.87 384.16 632.74 381.1 629.54 381.17 626.34 381.1 624.21 384.16 624.02 391.91 620.72 407.21 629.54 407.21 638.36 407.21 635.07 391.91",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.06 391.81 634.87 384.16 632.74 381.1 629.54 381.17 626.34 381.1 624.21 384.16 624.02 391.81 635.06 391.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.44,371h3.39a2.12,2.12,0,0,1,2.12,2.12v3.17a0,0,0,0,1,0,0h-7.63a0,0,0,0,1,0,0v-3.17A2.12,2.12,0,0,1,619.44,371Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.8,381.14c-.65-2.45-5.22-4.83-5.22-4.83h-7.74s-4.57,2.38-5.21,4.83,0,6.75,0,6.75H629.8S630.44,383.6,629.8,381.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,394.49H628.4a1.78,1.78,0,0,1,1.78,1.78v16.32a0,0,0,0,1,0,0H611.24a0,0,0,0,1,0,0V396.26A1.78,1.78,0,0,1,613,394.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.7,387.89H611.63a7.22,7.22,0,0,1,1.85,3c.44,1.69-1.58,3.84-1.58,3.84h17.52s-2-2.15-1.57-3.84A7.22,7.22,0,0,1,629.7,387.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.6,417.18h6.2s2.41,16.22,3,23.23S662,456.63,657.2,458l-4.81,1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 655.99,
    y: 413.98,
    width: 4.21,
    height: 7.21,
    transform: "translate(41.94 -59.72) rotate(5.37)",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.45,478H604.59a2.84,2.84,0,0,1-2.82-2.45l-9.69-69.86H659l-9.69,69.86A2.84,2.84,0,0,1,646.45,478Z",
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.94,
    y: 405.69,
    width: 73.16,
    height: 3.17,
    style: {
      fill: "#008C8E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 635.32,
    y1: 416.6,
    x2: 644.85,
    y2: 416.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.57,
    y1: 416.6,
    x2: 631.59,
    y2: 416.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.24,362.85a5.85,5.85,0,0,0-5.83-5.31h-1.74V343.7a3.75,3.75,0,0,0-3.76-3.75H145.5a3.75,3.75,0,0,0-3.75,3.75v13.84H140a5.84,5.84,0,0,0-5.82,5.31l-9.43,110.32,18.45.38.33-3.06a6.08,6.08,0,0,1,6-5.44h36.27a6.09,6.09,0,0,1,6,5.44l.33,3.06,18.44-.38ZM181,356H154.43v-8.22H181Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.63,427.27H144.91a4.8,4.8,0,0,1-4.13-7.24l23.86-40.34h0a4.8,4.8,0,0,1,8.26,0L196.76,420a4.8,4.8,0,0,1-4.13,7.24Zm-24.55-45.54-23.86,40.34a.77.77,0,0,0,0,.8.75.75,0,0,0,.69.4h47.72a.78.78,0,0,0,.69-.4.75.75,0,0,0,0-.8l-23.86-40.34a.76.76,0,0,0-.68-.39.78.78,0,0,0-.69.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.88,408.51c.77.14,1.44.28,2.12.38a1.22,1.22,0,0,1,1.1.95c.43,1.74.85,3.49,1.23,5.24a1.38,1.38,0,0,1-1.08,1.57,1.4,1.4,0,0,1-1.68-1c-.3-1.21-.59-2.42-.85-3.64a.65.65,0,0,0-.63-.62c-1.05-.15-2.1-.36-3.14-.55a2.21,2.21,0,0,1-1.79-1.69c-.38-1.29-.74-2.58-1.11-3.86,0-.15-.09-.29-.16-.5-.11.14-.2.23-.27.33-.39.58-.79,1.16-1.17,1.75a1,1,0,0,1-1,.55c-1.16,0-2.32,0-3.48,0a6.83,6.83,0,0,0-.77.06,1.06,1.06,0,0,1-1.2-1.11.87.87,0,0,1,.92-.86c1.19,0,2.38,0,3.56,0a.79.79,0,0,0,.81-.43q1.14-1.89,2.35-3.75a3,3,0,0,1,.8-.86c2.28-1.65,4.58-3.27,6.88-4.9l.27-.17a1.06,1.06,0,0,1,1.44.35,1,1,0,0,1-.3,1.4q-1.8,1.29-3.62,2.56c-.37.27-.75.52-1.11.8a.48.48,0,0,0-.18.36c.42,1.58.85,3.17,1.3,4.82l.43-.3c.95-.69,1.9-1.38,2.84-2.08A1.63,1.63,0,0,1,175,403l5.48,1.72a1.35,1.35,0,0,1,1,1.7,1.42,1.42,0,0,1-1.79.92c-1.53-.47-3.06-.94-4.57-1.43a.89.89,0,0,0-.91.15c-.95.73-1.92,1.41-2.87,2.12C171.18,408.26,171.07,408.36,170.88,408.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,417.64v2.49H156v-2.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,401.22a2.25,2.25,0,0,1-2.27-2.25,2.27,2.27,0,1,1,2.27,2.25Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.69,373.89a3.36,3.36,0,0,1-1.75-.4,2.19,2.19,0,0,1-.9-1.13,5,5,0,0,1-.27-1.71v-3.51a5,5,0,0,1,.27-1.73,2.13,2.13,0,0,1,.9-1.12,3.26,3.26,0,0,1,1.75-.4,3.34,3.34,0,0,1,1.69.36,1.88,1.88,0,0,1,.85,1,3.88,3.88,0,0,1,.26,1.46v.84h-2.1v-1a4.8,4.8,0,0,0,0-.55.77.77,0,0,0-.18-.44.59.59,0,0,0-.49-.18.65.65,0,0,0-.5.18.85.85,0,0,0-.2.45,3.48,3.48,0,0,0,0,.57v4.58a2.76,2.76,0,0,0,.05.59.84.84,0,0,0,.22.43.61.61,0,0,0,.47.16.59.59,0,0,0,.48-.17.83.83,0,0,0,.18-.45,5.09,5.09,0,0,0,0-.56v-1h2.1V371a4.29,4.29,0,0,1-.25,1.48,2,2,0,0,1-.85,1A3.24,3.24,0,0,1,149.69,373.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.19,373.74,155,364h2.45l1.81,9.72h-2l-.32-2.05h-1.43l-.34,2.05Zm2.56-3.33h1l-.51-3.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163,373.89a3.53,3.53,0,0,1-1.75-.37,2,2,0,0,1-.88-1.07,5,5,0,0,1-.25-1.72V364h2.12v7a4,4,0,0,0,.05.6,1,1,0,0,0,.21.49.61.61,0,0,0,.5.19.59.59,0,0,0,.5-.19,1,1,0,0,0,.2-.49,4,4,0,0,0,0-.6v-7h2.14v6.71a5,5,0,0,1-.26,1.72,2,2,0,0,1-.88,1.07A3.52,3.52,0,0,1,163,373.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.11,373.74v-8.12h-1.46V364h5.07v1.6h-1.45v8.12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.59,373.74V364h2.14v9.72Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179,373.89a3.31,3.31,0,0,1-1.73-.39,2.11,2.11,0,0,1-.91-1.1,4.88,4.88,0,0,1-.28-1.72v-3.61a4.78,4.78,0,0,1,.28-1.71,2.09,2.09,0,0,1,.91-1.09,3.41,3.41,0,0,1,1.73-.38,3.47,3.47,0,0,1,1.75.38,2.09,2.09,0,0,1,.91,1.09,4.57,4.57,0,0,1,.28,1.71v3.61a4.66,4.66,0,0,1-.28,1.72,2.11,2.11,0,0,1-.91,1.1A3.36,3.36,0,0,1,179,373.89Zm0-1.53a.64.64,0,0,0,.49-.16.91.91,0,0,0,.21-.44,3.12,3.12,0,0,0,0-.54v-4.68a3.12,3.12,0,0,0,0-.54.87.87,0,0,0-.21-.43.65.65,0,0,0-.49-.17.63.63,0,0,0-.47.17.86.86,0,0,0-.2.43,3.1,3.1,0,0,0-.05.54v4.68a3.12,3.12,0,0,0,0,.54.88.88,0,0,0,.19.44A.64.64,0,0,0,179,372.36Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.22,373.74V364h1.51l2,4.68V364h1.78v9.72h-1.45l-2-5v5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.88,444.61l-1.38-11.46h2.14l.68,6.68.87-6.66h1.68l.91,6.62.69-6.64h2.12l-1.37,11.46H142l-1-6.92-.92,6.92Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.76,444.61V433.15h5.15v1.73H149.3v2.84h2v1.76h-2v3.42h2.64v1.71Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.12,444.61V435h-1.73v-1.89h6V435h-1.71v9.57Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163,444.61V433.15H168v1.72h-2.41v2.88h2.1v1.77h-2.1v5.09Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.07,444.61V433.15h2.53v9.75h2.63v1.71Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.44,444.78a4,4,0,0,1-2-.45,2.57,2.57,0,0,1-1.08-1.3,5.82,5.82,0,0,1-.32-2v-4.26a5.71,5.71,0,0,1,.32-2,2.54,2.54,0,0,1,1.08-1.29,4.06,4.06,0,0,1,2-.44,4.11,4.11,0,0,1,2.05.44,2.51,2.51,0,0,1,1.09,1.29,5.71,5.71,0,0,1,.32,2V441a5.82,5.82,0,0,1-.32,2,2.54,2.54,0,0,1-1.09,1.3A4,4,0,0,1,178.44,444.78Zm0-1.79a.78.78,0,0,0,.58-.2,1,1,0,0,0,.24-.51,4.48,4.48,0,0,0,.05-.64v-5.52a4.37,4.37,0,0,0-.05-.64,1,1,0,0,0-.24-.5.78.78,0,0,0-.58-.2.75.75,0,0,0-.56.2,1,1,0,0,0-.24.5,4.37,4.37,0,0,0,0,.64v5.52a3.39,3.39,0,0,0,0,.64.92.92,0,0,0,.22.51A.75.75,0,0,0,178.44,443Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.72,444.78a3.94,3.94,0,0,1-2-.45,2.57,2.57,0,0,1-1.08-1.3,5.82,5.82,0,0,1-.32-2v-4.26a5.71,5.71,0,0,1,.32-2,2.54,2.54,0,0,1,1.08-1.29,4,4,0,0,1,2-.44,4.12,4.12,0,0,1,2.06.44,2.45,2.45,0,0,1,1.08,1.29,5.48,5.48,0,0,1,.33,2V441a5.59,5.59,0,0,1-.33,2,2.47,2.47,0,0,1-1.08,1.3A4,4,0,0,1,186.72,444.78Zm0-1.79a.75.75,0,0,0,.58-.2,1,1,0,0,0,.25-.51,4.48,4.48,0,0,0,0-.64v-5.52a4.37,4.37,0,0,0,0-.64,1,1,0,0,0-.25-.5.75.75,0,0,0-.58-.2.74.74,0,0,0-.55.2,1,1,0,0,0-.24.5,3.32,3.32,0,0,0-.05.64v5.52a3.39,3.39,0,0,0,.05.64.92.92,0,0,0,.22.51A.74.74,0,0,0,186.72,443Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M191.73,444.61V433.15h3.16a7.06,7.06,0,0,1,2,.26,2.46,2.46,0,0,1,1.32.91,3.19,3.19,0,0,1,.47,1.86,6.79,6.79,0,0,1-.11,1.26,2.36,2.36,0,0,1-.42.95,2.26,2.26,0,0,1-.87.68l1.57,5.54h-2.62L195,439.48h-.73v5.13Zm2.53-6.59H195a1.54,1.54,0,0,0,.84-.19,1,1,0,0,0,.41-.55,2.77,2.77,0,0,0,.12-.87,2.1,2.1,0,0,0-.27-1.15,1.08,1.08,0,0,0-1-.41h-.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningImg);
export default __webpack_public_path__ + "static/media/cleaning_img.990abc494321c4b4bf9dae656a897f5f.svg";
export { ForwardRef as ReactComponent };